import React, { Component } from 'react';
import { Menu, Label } from 'semantic-ui-react';
import { NavLink, Redirect, Switch } from 'react-router-dom';
import styled from 'react-emotion';
import { connect } from 'react-redux';

import usersAccessApi from '../../store/services/userAccess';
import Page from '../layout/Page';
import AllUsersTable from './AllUsersTable';
import RequestsTable from './RequestsTable';
import NewUserScreen from './NewUserScreen';
import RequiresRole, { ROLES } from '../security/RequiresRole';
import AuthorizedRoute from '../security/AuthorizedRoute';
import NewBlacklistScreen from '../blacklists/NewBlacklistScreen';

const PageWrapper = styled(Page.Basic)`
  .ui.menu .item {
    height: 42px;

    > .label.request-badge {
      background: #dfae38;
    }
  }
`;

class IndexScreen extends Component {
  state = {
    requestCount: undefined,
  };

  componentDidMount() {
    this._loadRequestsCount();
  }

  _loadRequestsCount = async () => {
    if (this.props.user.role === ROLES.SYSTEM_ADMIN) {
      const {
        result: { totalCount },
      } = await usersAccessApi.fetchPending();

      this.setState({ requestCount: totalCount });
    }
  };

  render() {
    const { requestCount } = this.state;
    return (
      <PageWrapper
        title="Manage Users"
        secondary={
          <Menu secondary pointing>
            <Menu.Item as={NavLink} to="/manage/users" exact>
              All Users
            </Menu.Item>
            <RequiresRole roles={[ROLES.SYSTEM_ADMIN]}>
              <Menu.Item as={NavLink} to="/manage/users/requests">
                Requests
                {!!requestCount && (
                  <Label size="mini" circular className="request-badge">
                    {requestCount}
                  </Label>
                )}
              </Menu.Item>
            </RequiresRole>
            <Menu.Item as={NavLink} to="/manage/users/new">
              Add New User
            </Menu.Item>
            <Menu.Item exact as={NavLink} to="/manage/blacklists/new">
              Blacklist a User
            </Menu.Item>
            <Menu.Item exact as={NavLink} to="/manage/whitelists/new">
              Whitelist a User
            </Menu.Item>
          </Menu>
        }
      >
        <Switch>
          <AuthorizedRoute
            exact
            path="/manage/users"
            component={AllUsersTable}
            roles={[ROLES.SYSTEM_ADMIN, ROLES.MM_ADMIN, ROLES.CUSTOMER_ADMIN]}
          />
          <AuthorizedRoute
            path="/manage/users/requests"
            render={props => (
              <RequestsTable {...props} onUpdated={this._loadRequestsCount} />
            )}
            roles={[ROLES.SYSTEM_ADMIN]}
          />
          <AuthorizedRoute
            exact
            path="/manage/users/new"
            component={NewUserScreen}
            roles={[ROLES.SYSTEM_ADMIN, ROLES.MM_ADMIN, ROLES.CUSTOMER_ADMIN]}
          />
          <AuthorizedRoute
            exact
            path="/manage/blacklists/new"
            component={NewBlacklistScreen}
            roles={[ROLES.SYSTEM_ADMIN]}
          />
          <Redirect to="/manage/users" />
        </Switch>
      </PageWrapper>
    );
  }
}

const mapStateToProps = ({ identity }) => {
  return {
    user: identity.user,
  };
};

export default connect(mapStateToProps)(IndexScreen);
